import { renderHeader } from "../components/Header"
import { renderFooter } from "../components/Footer"
import { fetchStickers } from "../api/StickersAPI"
import { renderStickerCard } from "../components/StickerCard"

const PRODUCT_ID = "301a2-5a61-1d3d-a8b1-1f3a9b0b5452"
const PRODUCT_SLUG = "home"

export async function renderHomePage(root: HTMLElement) {

sessionStorage.setItem(
    "landing_product",
    PRODUCT_SLUG
  )

  root.innerHTML = ""

  

  const main = document.createElement("main")
  main.className = "landing-main"

  main.innerHTML = `

<section class="hero">

  <div class="hero-fixed-bar">
    <div class="hero-fixed-inner">

      <a
        class="login-button"
        href="https://app.fr.bezbolu.pro"
      >
        Увійти
      </a>

    </div>
  </div>

  <div class="hero-top">

    <img src="img/logo.png" class="hero-logo" alt="FrançaisBezBolu" >

  </div>



  <h1>
    Вивчайте французьку без “каші в голові”
  </h1>

  <p class="hero-subtitle">
    Зрозуміла граматика українською мовою + вправи після кожного кроку.<br>
    Рівень A2
  </p>

  <a href="#pricing" class="hero-button">
    Почати вже сьогодні
  </a>

</section>

<section class="landing-block">
 <div class="section-card">

    <h2>Вам знайоме це?</h2>

    <ul>
    <li>Ви вивчаєте французьку 2–3 роки, можливо навіть склали A2, але все ще плутаєтеся у відмінюванні, підрядних реченнях, прийменниках, артиклях</li>
    <li>Пояснення французькою тільки заплутують</li>
    <li>В голові каша замість системи</li>
    </ul>

    <p><strong>Головна проблема:</strong></p>

    <p>
    Ви не бачите структури мови.  
    Ви не розумієте логіку.  
    Вам ніхто не пояснив, ЧОМУ треба саме так.
    </p>


    <h2>Саме тому ми створили застосунок з іншою методикою</h2>

    <ul>
    <li> Вся граматика пояснюється українською</li>
    <li> Купа прикладів з перекладом</li>
    <li> Кожна тема розбита на маленькі логічні кроки</li>
    <li> Після кожного кроку — вправи</li>
    </ul>

    <p>
    Ви не просто виконуєте завдання.  
    Ви починаєте розуміти, як працює французька мова.
    </p>
      <div class="card-cta">
        <a href="#pricing" class="cta-button">
        Хочу почати заняття
        </a>
      </div>
  </div>
</section>


<section class="landing-block">
    <div class="section-card">

    <h2>Як це працює</h2>

<p><strong>Принцип «по трохи, але щодня»</strong></p>
<p>
Вся граматика рівня А2 розбита на маленькі «кроки», які представляють собою мікро-уроки. В кожному кроці пояснюється невелика порція граматики (а іноді і лексики), оскільки маленькі порції інформації краще засвоюються. 
</p>

<p>
Кроки об’єднані в тематичні уроки. Наприклад, урок, присвячений артиклям, розбитий на 4 кроки: <br>
Крок 1. Означений та неозначений артиклі, злитий артикль (повторенні з рівня А1); <br>
Крок 2. Article partitif<br>
Крок 3. Заміна артиклів прийменником de<br>
Крок 4. Вживання прийменника de зі словами, що позначають кількість<br>
А урок, присвячений особовим займенникам в ролі підмета та додатків (в тому числі і займенникам y / en), розбитий аж на 8 кроків.
</p>

<p>
Кожен крок починається з детального пояснення, за яким ідуть вправи, в тому числі і на переклад з української на французьку. 
</p>
<p>
Ви можете займатися на телефоні, планшеті або комп’ютері.
</p>


<h2>Типи підписок</h2>

<p>
Ви можете вибрати програму «Активний» (1 крок щодня)
або «Спокійний» (3 кроки на тиждень).
</p>

<p>
Ми також додали програму «Без поспіху». Вона призначена не для повноцінних занять, а для того, щоб наздогнати накопичені, але не пройдені кроки. Вона також ідеальна, якщо ви плануєте відпустку і не зможете присвятити заняттям багато часу. 
</p>

<p>
З програмою «Без поспіху» у вас збережеться повний доступ до платформи за символічну плату в 104 грн (2 євро) на місяць.
</p>

<p>
Кроки не згорають — ви проходите їх тоді, коли знайдете час.
</p>
    <div class="card-cta">
    <a href="#pricing" class="cta-button">
    Хочу почати заняття
    </a>
    </div>

  </div>
</section>


<section class="landing-block">
  <div class="section-card">

    <h2>Що входить у програму</h2>

<p>
Вся граматика рівня A2 (часто навіть з частинами B1, оскільки межі між рівнями дуже умовні).
</p>

<p>
Матеріал подається логічно і послідовно.
</p>

<p>
Кожна тема супроводжується вправами, в тому числі і на переклад, що максимально активізує наш мозок.
</p>



<h2>Чим ми відрізняємось від інших застосунків</h2>

<ol>

<li>
Продумана структура подачі матеріалу
</li>

<li>
Зрозумілі пояснення
</li>

<li>
Розумні вправи без вгадування
</li>

</ol>
    <div class="card-cta">
    <a href="#pricing" class="cta-button">
    Хочу на заняття
    </a>
    </div>

  </div>

</section>


<section id="pricing" class="pricing">

<h2>Підписка</h2>

<div id="stickers">
Завантаження тарифів...
</div>

</section>

`

  root.appendChild(main)

  root.appendChild(renderFooter())

  try {

      const stickers = await fetchStickers()

      const container = document.getElementById("stickers")!

      container.innerHTML = ""

      stickers
        .filter(
          sticker => sticker.product_id === PRODUCT_ID
        )
        .sort((a, b) => a.priority - b.priority)
        .forEach(sticker => {

          container.appendChild(
            renderStickerCard(sticker)
          )

        })

  } catch {

    const container = document.getElementById("stickers")!

    container.innerHTML = "Не вдалося завантажити тарифи"

  }

}